import React, {useEffect} from "react";

export default function Background()
{
    useEffect(() =>
        {
            const particleLayer = document.getElementById("particleLayer");
            if (!particleLayer) return;

            const particleCount = 30;

            for (let i = 0; i < particleCount; i++)
            {
                const particle = document.createElement("div");
                particle.className = "particle";

                particle.style.left = Math.random() * 100 + "%";
                particle.style.animationDelay = Math.random() * 20 + "s";
                particle.style.animationDuration = 15 + Math.random() * 10 + "s";

                particleLayer.appendChild(particle);
            }
        },
        []);

    return(
        <div className="animated-background">
            <div className="gradient-layer"></div>
            <div className="floating-shapes">
                <div className="shape"></div>
                <div className="shape"></div>
                <div className="shape"></div>
                <div className="shape"></div>
                <div className="shape"></div>
                <div className="shape"></div>
            </div>
            <div className="particle-layer" id="particleLayer"></div>
        </div>
    );
};